export default __webpack_public_path__ + "static/media/hippo_ANGRY.611363f5.png";